import { Component,ViewChild } from '@angular/core';
import { ModalComponent } from '../modal.component/modal.component';
import { ModalBase } from 'src/app/model/modal-base';

@Component({
    selector: 'app-bank-info-modal',
    templateUrl: './bank-info-modal.component.html',
    styleUrls: ['./bank-info-modal.component.scss'],
    // encapsulation: ViewEncapsulation.None
})
export class BankInfoModalComponent //extends ModalBase
{
    @ViewChild('modal', { static: true })
    public modal: ModalComponent;

    public open(): void
    {
        this.modal.open();
    }
    public closeModal(): void
    {
        this.modal.close();
    }
}
